import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// Magic link callback. The Supabase client automatically processes the URL hash on
// page load (because detectSessionInUrl=true). All we need to do is wait for the
// session to be established and then redirect to /app.
export function AuthCallbackScreen() {
  const navigate = useNavigate();
  const { loading, session } = useAuth();

  useEffect(() => {
    if (loading) return;
    if (session) {
      navigate('/app', { replace: true });
    } else {
      // The token was probably expired or already used. Send the user back to /signin.
      navigate('/signin?error=expired', { replace: true });
    }
  }, [loading, session, navigate]);

  return (
    <main className="min-h-full grid place-items-center bg-cream p-8">
      <div className="text-center">
        <div className="mx-auto w-12 h-12 rounded-full border-2 border-accent/30 border-t-accent animate-spin" />
        <p className="mt-4 text-sm text-ink/60">Signing you in...</p>
      </div>
    </main>
  );
}
